export const DEFAULT_INITIATE_PROPOSAL_FORM_ID = 'default-initiate-proposal-form';

export const ALLIED_INITIATE_PROPOSAL_FORM_ID = 'allied-initiate-proposal-form';

export const SUN_LIFE_INITIATE_PROPOSAL_FORM_ID = 'sun-life-initiate-proposal-form';
export const SUN_LIFE_SIC_WARNING_ALERT_TEST_ID = 'sun-life-initiate-proposal-sic-warning-alert';

export const AVAILABLE_PRODUCT_LINES_LIST_TEST_ID = 'available-product-lines-list';
export const AVAILABLE_PRODUCT_LINES_HINT_TEST_ID = 'available-product-lines-hint';
export const AVAILABLE_PRODUCT_LINES_SKELETON_TEST_ID = 'available-product-lines-skeleton';
